import { render, staticRenderFns } from "./single_news.vue?vue&type=template&id=777bbf41&scoped=true"
import script from "./single_news.vue?vue&type=script&lang=js"
export * from "./single_news.vue?vue&type=script&lang=js"
import style0 from "./single_news.vue?vue&type=style&index=0&id=777bbf41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777bbf41",
  null
  
)

export default component.exports